module.exports = __webpack_public_path__ + "img/通威农牧.452c4566.png";